<template>
  <v-row>
    <v-col
      v-if="!hideDivider"
      :cols="12 - indent"
      :offset="indent"
    >
      <v-divider></v-divider>
    </v-col>
    <v-col :cols="2" :offset="indent">
      <p class="author">{{comment.author}}</p>
      <p class="posted">{{postedAt(comment.timestamp)}}</p>
    </v-col>
    <v-col :cols="10 - indent">
      <p class="rating" v-if="comment.rating">
        <v-icon small v-for="(index) in [1, 2, 3, 4, 5]" :key="index">
          {{index > comment.rating  ? 'mdi-star-outline' : 'mdi-star'}}
        </v-icon>
      </p>
      <p>{{comment.text}}</p>
      <v-btn
        outlined
        small
        text
        v-if="comment.replies"
        @click="onReply(comment)"
      >Reply</v-btn>
      <template v-if="showCommentForm">
        <comment-form
          disable-ratings
          :title="`Reply to ${replyToAuthor}`"
          @cancel="onCancel"
          @submit="submitReply"
        ></comment-form>
      </template>
    </v-col>
    <v-col v-if="comment.replies">
      <comment-block
        v-for="(reply, index) in comment.replies"
        :key="index"
        :comment="reply"
        :indent="indent + 1"
      ></comment-block>
    </v-col>
  </v-row>
</template>

<script>
import {
  VBtn,
  VCol,
  VDivider,
  VIcon,
  VRow,
} from 'vuetify/lib'
import moment from 'moment'

import CommentForm from '@/components/CommentForm'

export default {
  components: {
    CommentForm,
    VBtn,
    VCol,
    VDivider,
    VIcon,
    VRow,
  },
  data: () => ({
    showCommentForm: false,
    replyToAuthor: '',
  }),
  methods: {
    postedAt(timestamp) {
      return moment(timestamp.toDate())
          .format('DD MMM YYYY [at] h:mma')
    },
    onCancel() {
      this.showCommentForm = false
      this.replyToAuthor = ''
    },
    onReply(comment) {
      this.showCommentForm = true
      this.replyToAuthor = comment.author
    },
    submitReply(reply) {
      this.$emit('submitReply', {
        commentId: this.comment.id,
        ...reply,
      })
    }
  },
  name: 'comment-block',
  props: {
    comment: Object,
    indent: {
      default: 0,
      type: Number,
    },
    hideDivider: {
      default: false,
      type: Boolean,
    }
  }
}
</script>

<style scoped>
.author {
  font-weight: bold;
  text-transform: uppercase;
}

.posted {
  font-size: 13px;
}

.rating {
  margin: 0 0 5px 0;
}
</style>
